import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTheme } from './utils/store';

export const createAppTheme = (mode: 'light' | 'dark') =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: '#5a76f5',
      },
    },
    components: {
      MuiAvatar: {
        styleOverrides: {
          root: ({ theme }) => ({
            ...(theme.palette.mode === 'dark' && {
              borderColor: '#fff !important',
            }),
          }),
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: ({ theme }) => ({
            ...(theme.palette.mode === 'dark' && {
              backgroundImage: 'none',
              backgroundColor: '#2c2c2b',
            }),
          }),
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            padding: '14px 30px',
          },
          icon: ({ theme }) => ({
            right: 12,
            ...(theme.palette.mode === 'dark' && {
              color: '#CCC',
            }),
          }),
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            border: 'none',
          },
        },
      },
    },
  });

const MuiThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  const muiTheme = createAppTheme(theme);
  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default MuiThemeWrapper;
